document.addEventListener('DOMContentLoaded', function () {
  var carouselElement = document.querySelector('.prefooter-carousel');
  var flkty;

  var options = {};
  var config = document.querySelector('.Prefooter[data-flickity-config]');
  if (config) {
    options = JSON.parse(config.getAttribute('data-flickity-config'));
  }

  refreshPrefooter();
  window.addEventListener('resize', () => {
    refreshPrefooter();
  });

  function refreshPrefooter() {    
    if (respondToBreakpoint('pocket')) {
      initFlkty();
    } else {
      destroyFlkty();
    }
  }

  function destroyFlkty() {
    if (flkty !== null && flkty !== undefined) {
      flkty.destroy();
      flkty = null;
    }
  }

  function initFlkty() {
    if (flkty === null || flkty === undefined) {
      flkty = new window.Flickity(carouselElement, {
        ...options
      });
    }
  }
});
